import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import { IconChevronDown, IconSettings, IconLogOut, IconMenu } from '../atoms/Icon';
import { useAuth } from '../contexts/AuthContext';
import packageJson from '../../package.json';

const appVersion = packageJson.version;

function getInitial(name) {
  return (name || 'E').trim().charAt(0).toUpperCase();
}

function TopBar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const { establishment, logout } = useAuth();

  function handleLogout() {
    logout();
    navigate('/entrar');
  }

  return (
    <Navbar
      className="d-none d-md-flex px-3 px-md-4 border-bottom"
      style={{ backgroundColor: '#fff', height: 64, flexShrink: 0 }}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onOpenSidebar(); }}
        aria-label="Abrir menu"
        className="d-none d-md-flex d-lg-none topbar-icon-btn"
      >
        <IconMenu size={20} />
      </button>

      <div className="ms-auto d-flex align-items-center gap-3">
        <Dropdown align="end">
          <Dropdown.Toggle
            as="div"
            id="topbar-user-menu"
            bsPrefix="topbar-user-toggle"
            className="d-flex align-items-center gap-2"
          >
            <div className="topbar-avatar" title="Meu perfil">
              {establishment?.logoUrl ? (
                <img src={establishment.logoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
              ) : (
                getInitial(establishment?.name)
              )}
            </div>
            <div className="d-none d-sm-block" style={{ lineHeight: 1.2 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-neutral)' }}>
                {establishment?.name || 'Estabelecimento'}
              </span>
              <div style={{ fontSize: 11, color: '#aaa' }}>{establishment?.email}</div>
            </div>
            <IconChevronDown size={16} style={{ color: '#aaa' }} />
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{
              minWidth: 210,
              borderRadius: 10,
              border: '1px solid #f0f0f0',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
              padding: 6,
            }}
          >
            <Dropdown.Item
              onClick={() => navigate('/configuracoes')}
              className="d-none d-md-flex align-items-center gap-2"
              style={{ borderRadius: 6, fontSize: 13, padding: '8px 10px' }}
            >
              <IconSettings size={15} />
              Configurações
            </Dropdown.Item>
            <Dropdown.Divider className="d-none d-md-block" style={{ margin: '4px 0' }} />
            <Dropdown.Item
              onClick={handleLogout}
              className="d-flex align-items-center gap-2"
              style={{ borderRadius: 6, fontSize: 13, padding: '8px 10px', color: '#e74c3c' }}
            >
              <IconLogOut size={15} />
              Sair
            </Dropdown.Item>
            <div
              className="text-center"
              style={{ fontSize: 10, color: '#ccc', padding: '8px 10px 2px' }}
            >
              MyPedidos v{appVersion}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </Navbar>
  );
}

export default TopBar;
